import React from 'react'
import { Outlet } from 'react-router-dom';

function VisitorLayout() {
    return (
        <div className="thales-view-auth">
            <Outlet />
        </div>
    )
}
export default VisitorLayout;